export const STRIPE_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  RESTRICTED: 'restricted',
  REJECTED: 'rejected',
}
